<script>
    import { createEventDispatcher } from "svelte";
    export let searchTerm = "";
    export let placeholder = "";
    export let className = "";
    export let disabled = false;
    export let id = "";

    const dispatch = createEventDispatcher();
    let focusOutAction = () => {
        dispatch("focusout");
    }
</script>

<input id="{id}" class="form-control {className}" type="text" bind:value={searchTerm} on:focusout={focusOutAction} on:input autocomplete="off" placeholder="{placeholder}" disabled="{disabled}">

<style>
     input[type="text"]:disabled {
         background: #d5e2ee;
    }
</style>